import React from 'react';
import { useNavigate } from "react-router-dom";
import { urls, listTypes } from '../../constants.js';
import { Button } from 'react-bootstrap';
import i18next from "../../i18n.js";

const DocumentHeader = (props) => {
    const navigate = useNavigate();

    const handleBackClick = () => {
        if (props.handleBackClick) {
            props.handleBackClick();
        }
        else {
            const urlParams = new URLSearchParams(document.location.search);
            const returnParam = urlParams.get('return');
            if (returnParam) {
                window.location.replace(`${document.location.origin}${returnParam}`);
            }
            else {
                switch (props.type) {
                    case listTypes.Documents:
                        navigate(urls.documentsPage);
                        break;
                    case listTypes.Tasks:
                        navigate(urls.tasksPage);
                        break;
                    default:
                        navigate(urls.mainPage);
                        break;
                }
            }
        }
    };

    return (
        <div className="header">
            <div className="back-link" onClick={handleBackClick} />
            <div className="header-title">
                {props.title}
            </div>
            {/* додаткові дії документа, які мають стояти в шапці поруч із кнопкою закриття */}
            {props.children}
            <Button className='header-btn close' onClick={handleBackClick} title={i18next.t('other.closeDocument')} />
        </div>
    );
};

export default DocumentHeader;